import Vue from 'vue'
import Vuex from 'vuex'
import startstore from './start.store'

Vue.use(Vuex)

export const state = {
  isLoaderOn: false,
  allEnvironments: ['Production', 'Sandbox', 'Stage', 'ITF'],
  allSdkLoaded: false,
  transactionAmount: 100
}

export const getters = {
  loaderOn (state) {
    return state.isLoaderOn
  },
  allEnvironments () {
    return state.allEnvironments
  },

  allSdkLoaded () {
    return state.allSdkLoaded
  }
}
export const actions = {

  loaderOn ({ commit }, isLoading) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('loaderOn', isLoading)
        resolve()
      }, 100)
    })
  },

  changeAllEnvironments ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeAllEnvironments', value)
        resolve()
      }, 100)
    })
  },

  updateAllSdkLoaded ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeAllSdkLoaded', value)
        resolve()
      }, 100)
    })
  }

}
export const mutations = {
  loaderOn (state, isLoading) {
    state.isLoaderOn = isLoading
  },
  changeAllEnvironments (state, value) {
    state.allEnvironments = value
  },

  changeAllSdkLoaded (state, value) {
    state.allSdkLoaded = value
  }
}

export const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,

  modules: {
    startstore
  }
})
